import {
  axiosGet,
  axiosPatch,
  axiosPost,
  axiosDelete,
} from "../../../app/Helpers/AxiosHelper";

import {
  CONVERSATIONS,
  CHATUSERS,
  UNAUTHCONVERSATIONS,
  UNAUTHCHATUSERS,
} from "../../../app/Config/ApiUrl";

// const ably = new Ably.Realtime('<YOUR_ABLY_API_KEY>');

import Ably from "ably";
import {
  initializeAblyClient,
  fetchTokens,
} from "../../../app/Components/Views/LiveChat/services/AblyService.js";
import { processIncommingMessage } from "../../../app/Components/Views/LiveChat/Processors/MessageProcessor.js";
import { processConversation } from "../../../app/Components/Views/LiveChat/Processors/ConversationProcessor.js";
export default {
  state: {
    ablyClient: null,
    notification: "",
    conversations_per_page: 20,
    conversations_loading: false,
    conversations_more_loading: false,
    user: null,
    conversation: {},
    connection_status: "",
    typingUsers: [],
    show_conversations: false,
    global_conversations: {
      total_size: 0,
      limit: 20,
      current_page: 0,
      offset: 0,
      data: [],
    },
    conversation_sections: [],

    isAuth: false,
    activeUsers: [],
    locationId: null,
    conversations: {
      total_size: 0,
      limit: 20,
      current_page: 0,
      offset: 0,
      data: [],
    },

    missed_messages: {
      dm: 0,
      channel: 0,
    },

    selectedContact: null,
    selectedContactMain: null,
    conversationSubscription: null,
    mainContactedSelected: false,
    activeCon: null,
    messages: {
      total_size: 0,
      limit: 25,
      current_page: 1,
      offset: 0,
      data: [],
    },

    more_message_loading: false,
    message_loading: false,
    message_sending: false,
    chat_users: {
      loaded: false,
      data: [],
      error: false,
    },
  },

  getters: {
    ablyClient(state) {
      return state.ablyClient;
    },
    getisAuth: (state) => state.isAuth,
    getactivecon: (state) => state.activeCon,
    getmaincontactSelected: (state) => state.mainContactedSelected,
    getConversationsPerPage: (state) => state.conversations_per_page,
    getConversationsLoading: (state) => state.conversations_loading,
    getConversationsMoreLoading: (state) => state.conversations_more_loading,
    getTaskUser: (state) => state.user,
    missedMessages: (state) => state.missed_messages,
    getConnectionStatus: (state) => state.connection_status,
    getActiveUsers: (state) => state.activeUsers,
    showConversations: (state) => state.show_conversations,
    isTyping: (state) => (channelId, userId) => {
      return (
        state.typingUsers[channelId] && state.typingUsers[channelId][userId]
      );
    },

    typingUsers: (state) => state.typingUsers,

    conversations: (state) => {
      return {
        ...state.conversations,
      };
    },

    globalconversations: (state) => {
      return {
        ...state.global_conversations,
      };
    },

    getConversationSections: (state) => {
      return {
        ...state.conversation_sections,
      };
    },

    getChatUsers: (state) => {
      return {
        ...state.chat_users,
      };
    },

    getSelectedContact: (state) => {
      // return {
      //   ...state.selectedContact,
      // };
      return state.selectedContact;
    },

    getMessages: (state) => {
      return state.messages;
    },

    loadingMoreMessages: (state) => state.more_message_loading,
    getMessageLoading: (state) => state.message_loading,
    getMessageSending: (state) => state.message_sending,
  },

  mutations: {
    setAblyClient(state, ablyClient) {
      state.ablyClient = ablyClient;
    },

    setSelectedChat(state, data) {
      state.selectedContact = data;
    },

    removeUserActive(state, data) {
      const { user } = data;

      // Find the index of the user entry in typingUsers array
      const existingEntryIndex = state.activeUsers.findIndex(
        (entry) => entry.id === user.id
      );

      if (existingEntryIndex !== -1) {
        // Remove the entry
        state.activeUsers.splice(existingEntryIndex, 1);
      }
    },

    setShowConversations(state, data) {
      state.show_conversations = data;
    },

    setDeleteChannel(state, data) {
      const channelId = data;

      // Find the index of the user entry in typingUsers array
      const existingEntryIndex = state.conversations.data.findIndex(
        (entry) => entry.id === channelId
      );

      if (existingEntryIndex !== -1) {
        // Remove the entry
        state.conversations.data.splice(existingEntryIndex, 1);
      }  

      //check in global channel and update  


      const GexistingEntryIndex = state.global_conversations.data.findIndex(
        (entry) => entry.id === channelId
      );

      if (GexistingEntryIndex !== -1) {
        // Remove the entry
        state.global_conversations.data.splice(GexistingEntryIndex, 1);
      }


      //dis select the conversation.
      state.selectedContact = null;
      state.show_conversations = false;
    },


    updateConversationSection(state, { conversations, sections }) {
       
        state.conversations.data = conversations;
        state.conversation_sections.sections = sections;
       
    },   

    setUserActive(state, data) {
      const { user } = data;

      // Find the existing user entry
      const existingEntryIndex = state.activeUsers.findIndex((entry) => {
        return entry.id === user.id;
      });

      if (existingEntryIndex !== -1) {
        // Update existing entry
        state.activeUsers[existingEntryIndex] = user;
      } else {
        // Add new entry
        state.activeUsers.push(user);
      }
    },

    setTypingStatus(state, data) {
      const { channelId, userId, user, typing } = data;

      // Find the existing user entry
      const existingEntryIndex = state.typingUsers.findIndex(
        (user) => user.channelId === channelId && user.userId === userId
      );

      if (existingEntryIndex !== -1) {
        if (typing) {
          // Update existing entry
          state.typingUsers[existingEntryIndex] = {
            channelId,
            userId,
            user,
            typing,
          };
        } else {
          // Remove the entry if the user is not typing
          state.typingUsers.splice(existingEntryIndex, 1);
        }
      } else if (typing) {
        // Add new entry only for active chat.

        if (
          channelId == state.selectedContact.id &&
          state.user.userID != userId
        ) {
          state.typingUsers.push({ channelId, userId, user, typing });
        }
      }
    },

    clearTypingStatus(state, data) {
      const { channelId, userId } = data;

      // Find the index of the user entry in typingUsers array
      const index = state.typingUsers.findIndex(
        (entry) => entry.channelId === channelId && entry.userId === userId
      );

      if (index !== -1) {
        // Remove the user entry from typingUsers array
        state.typingUsers.splice(index, 1);
      }
    },

    setConnectionStatus(state, status) {
      state.connection_status = status;
    },

    async setInit(state, locationId) {
      state.locationId = locationId;
      const locationchannel = state.ablyClient?.channels?.get(locationId);

      if (locationchannel) {
        //enter the channel and subscribe to it.
        locationchannel.presence.enter({ clientData: { user: state.user } });

        locationchannel.subscribe("message", (message) => {
          const data = processConversation(message.data);

          if (data.type == "NEWCONVERSATION") {
            if (state.user.id != data.data.created_by) {
              //check if it is a public channel or not
              if (data.data.public == 1) {
                state.conversations.data.push(data.data);
              } else {
                //check if you belong in the conversation users array.

                let belongTo = data.data.users.find(
                  (user) => user.id === state.user.id
                );
                if (belongTo) {
                  state.conversations.data.push(data.data);
                }
              }
            }
          } else if (data.type == "NOTIFICATION") {
            if (state.user?.id != data.data.sender.id) {
              let belongTo = data.data.conversation.users.filter(
                (user) => user.id == state.user.id
              );

              if (belongTo.length > 0) {
                if ( state.selectedContact?.uuid != data.data.conversation.uuid) { 

                  // state.conversations.data = state.conversations.data.map(
                  //   (conversation) => {
                  //     if (conversation.uuid === data.data.conversation.uuid) {
                  //       return {
                  //         ...conversation,
                  //         missed_messages: conversation.missed_messages + 1,
                  //       };
                  //     }
                  //     return conversation;
                  //   }
                  // );

                  state.conversations.data.forEach(conversation => {
                    if (conversation.uuid === data.data.conversation.uuid) {
                      conversation.missed_messages += 1;
                    }
                  });  

                  //update for conversations in conversation_sections 

                  if(!state.conversation_sections.sections) return

                  state.conversation_sections.sections.forEach(section => { 
                    section?.conversations?.forEach(conversation => {
                      if (conversation.uuid === data.data.conversation.uuid) {
                        conversation.missed_messages += 1;
                      }
                    }); 
                  });  



                }

                //reorder the conversation list
                // Find the index of the conversation with the updated message count
                const updatedConversationIndex =
                  state.conversations.data.findIndex(
                    (conversation) =>
                      conversation.uuid === data.data.conversation.uuid
                  );

                if (updatedConversationIndex !== -1) {
                  const updatedConversation =
                    state.conversations.data[updatedConversationIndex];

                  // Remove the conversation from the array
                  state.conversations.data.splice(updatedConversationIndex, 1);

                  // Add the updated conversation to the beginning of the array
                  state.conversations.data.unshift({
                    ...updatedConversation,
                    missed_messages: updatedConversation.missed_messages,
                    missed_count: updatedConversation.missed_count,
                  });
                }

                //update missed message count

                if (data.data.conversation.type == "1-to-1") {
                  state.missed_messages.dm = state.missed_messages.dm + 1;
                } else {
                  state.missed_messages.channel =
                    state.missed_messages.channel + 1;
                }

                //check if the user can recieve sound notification
                if (state.user.livechat_notification) {
                  const audio = new Audio("/livechat/notif.wav");

                  audio.play().catch((error) => {
                    console.error("Failed to play audio:", error);
                  });
                }
              }
            }
          } else if (data.type == "NEW_USER") {
            //update for global conversations
            state.conversations.data = state.conversations.data.map(
              (conversation) => {
                if (conversation.uuid === data.data.conversationId) {
                  return {
                    ...conversation,
                    users: conversation.users.concat(data.data.user),
                  };
                }
                return conversation;
              }
            );

            //update for selected conversation
            state.selectedContact.users = state.selectedContact?.users.concat(
              data.data.user
            );
          } else if (data.type == "CHAT_LOG") {
            //check if the message is send by the same user.
            if (
              state.user?.id == data.data.task_user_id &&
              state.mainContactedSelected == true
            ) {
              const messageExists = state.messages.data.some(
                (message) => message.id === data.data.id
              );

              if (!messageExists) {
                state.messages.data.push(data.data);

                if (state.user.livechat_notification) {
                  const audio = new Audio("/livechat/notif.wav");

                  audio.play().catch((error) => {
                    console.error("Failed to play audio:", error);
                  });
                }
              }
            }
          }
        });

        // lololo

        //get the current user state

        // await locationchannel.presence.subscribe(async (presenceMessage) => {

        //   const presenceSet = await locationchannel.presence.get();

        //   if (presenceSet.length > 0) {
        //     console.log('There are ' + presenceSet.length + ' members on this channel');
        //     console.log('Initial members:', presenceSet);
        //   } else {
        //     console.log('There are no members on this channel');
        //   }

        // });

        locationchannel.presence.subscribe("enter", (member) => {
          const clientData = member.data.clientData;

          this.commit("setUserActive", {
            user: clientData.user,
          });
        });

        locationchannel.presence.subscribe("leave", (member) => {
          const clientData = member.data.clientData;
          this.commit("removeUserActive", {
            user: clientData.user,
          });
        });
 
      }
    },

    setExternal(state, data) {
      state.isAuth = data;
    },

    setCompanyInit(state, data) {
      const { companyId, locationId } = data;
      const locationchannel = state.ablyClient?.channels?.get(companyId);

      if (locationchannel) {
        locationchannel.subscribe("message", (message) => {
          const data = processConversation(message.data);

          if (data.type == "NEWCONVERSATION") {
            if (state.user.id != data.data.created_by) {
              //check if it is a public channel or not
              if (data.data.belongs_to_all_locations == 1) {
                state.global_conversations.data.push(data.data);
              } else {
                //check if you belong in the Locations array.

                let belongTo = data.data.locations.find(
                  (location) => location.id === locationId
                );
                if (belongTo) {
                  state.global_conversations.data.push(data.data);
                }
              }
            }
          } else if (data.type == "NOTIFICATION") {
            if (state.user?.id != data.data.sender.id) {
              let belongTo = data.data.conversation.users.filter(
                (user) => user.id == state.user.id
              );

              if (belongTo.length > 0) {
                if (
                  state.selectedContact?.uuid != data.data.conversation.uuid
                ) {
                  state.global_conversations.data =
                    state.global_conversations.data.map((conversation) => {
                      if (conversation.uuid === data.data.conversation.uuid) {
                        return {
                          ...conversation,
                          missed_messages: conversation.missed_messages + 1,
                        };
                      }
                      return conversation;
                    });
                }

                //reorder the conversation list
                // Find the index of the conversation with the updated message count
                const updatedConversationIndex =
                  state.global_conversations.data.findIndex(
                    (conversation) =>
                      conversation.uuid === data.data.conversation.uuid
                  );

                if (updatedConversationIndex !== -1) {
                  const updatedConversation =
                    state.global_conversations.data[updatedConversationIndex];

                  // Remove the conversation from the array
                  state.global_conversations.data.splice(
                    updatedConversationIndex,
                    1
                  );

                  // Add the updated conversation to the beginning of the array
                  state.global_conversations.data.unshift({
                    ...updatedConversation,
                    missed_messages: updatedConversation.missed_messages,
                    missed_count: updatedConversation.missed_count,
                  });
                }

                //update missed message count

                if (data.data.conversation.type == "1-to-1") {
                  state.missed_messages.dm = state.missed_messages.dm + 1;
                } else {
                  state.missed_messages.channel =
                    state.missed_messages.channel + 1;
                }

                //check if the user can recieve sound notification
                if (state.user.livechat_notification) {
                  const audio = new Audio("/livechat/notif.wav");

                  audio.play().catch((error) => {
                    console.error("Failed to play audio:", error);
                  });
                }
              }
            }
          } else if (data.type == "NEW_USER") {
            //update for global conversations
            state.global_conversations.data =
              state.global_conversations.data.map((conversation) => {
                if (conversation.uuid === data.data.conversationId) {
                  return {
                    ...conversation,
                    users: conversation.users.concat(data.data.user),
                  };
                }
                return conversation;
              });

            //update for selected conversation
            state.selectedContact.users = state.selectedContact?.users.concat(
              data.data.user
            );
          }
        });
      }
    },

    setActiveCon(state, data) {
      state.activeCon = data;
    },

    setmissedMessages(state, data) {
      state.missed_messages.dm = 0;
      state.missed_messages.channel = 0;
    },

    SET_LIVECHAT_USER(state, data) {
      state.user = data;
    },

    SET_CONVERSATIONS_LOADING(state, data) {
      state.conversations_loading = data;
    },

    SET_MORE_CONVERSATIONS_LOADING(state, data) {
      state.conversations_more_loading = data;
    },

    SET_CONVERSATIONS(state, data) {
      state.conversations.current_page = data.current_page;
      state.conversations.total_size = data.total_size;
      state.conversations.limit = data.limit;

      state.conversations = {
        ...data,
        data: [...data.conversations],
      };
    },

    SET_CONVERSATION_SECTION(state, data) {
      state.conversation_sections = data;
    },

    SET_GLOBAL_CONVERSATIONS(state, data) {
      state.conversations.current_page = data.current_page;
      state.conversations.total_size = data.total_size;
      state.conversations.limit = data.limit;

      state.global_conversations = {
        ...data,
        data: [...data.conversations],
      };
    },

    SET_Reset_CONVERSATIONS(state, data) {
      state.conversations = {
        total_size: 0,
        limit: 20,
        current_page: 0,
        offset: 0,
        data: [],
      };
    },

    SET_LOAD_MORE_Conversations(state, data) {
      state.conversations.data = [
        ...state.conversations.data,
        ...data.conversations,
      ];
      state.conversations.current_page = data.current_page;

      // state.messages.data.push(data.data);
    },

    SET_CHAT_USERS(state, data) {
      state.chat_users = data;
    },

    //  async  SET_MAIN_CONTACT(state, data) {

    //    if (state.conversationSubscription) {
    //       const channel = state.ablyClient.channels.get(state.selectedContactMain);
    //    }

    //    if( !channel ){

    //     state.selectedContactMain = data;
    //     const newChannel = state.ablyClient.channels.get(data);

    //     if (newChannel) {
    //       state.conversationSubscription = newChannel.subscribe('message', (message) => {
    //
    //           const processedMessage = processIncommingMessage(message.data);
    //           state.messages.data.push(processedMessage);
    //       });
    //   } else {
    //       console.error('Error: New channel not found');
    //   }

    //    }

    //        },

    SET_MAIN_CONTACT_SELECTED(state, data) {
      state.mainContactedSelected = data;
      state.show_conversations = false;
    },

    SETUPDATECONVERSATIONUSER(state, users) {
      state.selectedContact.users = users;
    },

    SET_UPDATE_CONVERSATION(state, data) {
      state.conversations.data = state.conversations.data.map(
        (conversation) => {
          if (conversation.uuid === data.uuid) {
            return {
              ...conversation,
              ...data,
            };
          }
          return conversation;
        }
      );

      state.selectedContact = data;
    },
    
    async SET_SELECTED_CONTACT(state, data) {
      if(!data) return
      state.show_conversations = false;
      if (state.selectedContact?.uuid == data?.uuid) return;


      if (state.conversationSubscription && state.selectedContact) {
        const channel = state.ablyClient?.channels.get(state.selectedContact.uuid);
        if (channel) {
          try {
            if (typeof state.conversationSubscription === 'function') {
              state.conversationSubscription(); // Call unsubscribe
            }
            if (channel.state === 'attached') {
              await channel.detach();
            }
          } catch (error) {
            console.error('Cleanup error:', error);
          }
          state.conversationSubscription = null;
        }
      }



      

      state.selectedContact = data;
      try {
        const newChannel = state?.ablyClient?.channels.get(data.uuid);

        if (newChannel) {
          state.conversationSubscription = newChannel.subscribe(
            "message",
            (message) => {
              const processedMessage = processIncommingMessage(message.data);

              if (processedMessage.type == "NEWMESSAGE") {
                //check if the message is send by the same user.
                if (state.user?.id != processedMessage.data.sender.id) {
                  // state.messages.data.unshift(processedMessage.data);
                  state.messages.data.push(processedMessage.data);
                  //play notification

                  if (state.user.livechat_notification) {
                    const audio = new Audio("/livechat/notif.wav");

                    audio.play().catch((error) => {
                      console.error("Failed to play audio:", error);
                    });
                  }
                }
              } else if (processedMessage.type == "DELETEDMESSAGE") {
                state.messages.data = state.messages.data.filter(
                  (message) => message.id != processedMessage.uuid
                );
              } else if (processedMessage.type == "UPDATEMESSAGE") {
                state.messages.data = state.messages.data.map((message) =>
                  message.id == processedMessage.data.id
                    ? processedMessage.data
                    : message
                );
              }
            }
          );
 

        } else {
          console.error("Error: New channel not found");
        }
      } catch (error) {
        console.log(error);
      }
 


      state.conversations.data.forEach((conversation) => {
        if (conversation.uuid === data.uuid) {
          conversation.missed_messages = 0;
        }
      });

      

      //reset for conversations in conversation sections

      if(!state.conversation_sections.sections) return
      
      state.conversation_sections.sections.forEach(section => {
       
          section.conversations.forEach(conversation => {
            if (conversation.uuid === data.uuid) {
              // Directly update the properties
              conversation.missed_messages = 0;
              // Update other properties as needed
            }
          });
        
      });
      

    },

    async OLDSET_SELECTED_CONTACT(state, data) {
      if(!data) return
      state.show_conversations = false;
      if (state.selectedContact?.uuid == data?.uuid) return;

      // Unsubscribe from the previous conversation channel if it exists
      if (state.conversationSubscription) {
        //check if the conversation exist  

        if(state.selectedContact){ 
        const channel = state?.ablyClient?.channels.get(
          state.selectedContact.uuid
        );
        if (channel) {
          try {
            await channel.detach();
            channel.unsubscribe("message");
          } catch (error) {
            // console.error('Error unsubscribing from previous channel:', error);
          }
          state.conversationSubscription = null;
        }
      }
      }

      state.selectedContact = data;
      try {
        const newChannel = state?.ablyClient?.channels.get(data.uuid);

        if (newChannel) {
          state.conversationSubscription = newChannel.subscribe(
            "message",
            (message) => {
              const processedMessage = processIncommingMessage(message.data);

              if (processedMessage.type == "NEWMESSAGE") {
                //check if the message is send by the same user.
                if (state.user?.id != processedMessage.data.sender.id) {
                  // state.messages.data.unshift(processedMessage.data);
                  state.messages.data.push(processedMessage.data);
                  //play notification

                  if (state.user.livechat_notification) {
                    const audio = new Audio("/livechat/notif.wav");

                    audio.play().catch((error) => {
                      console.error("Failed to play audio:", error);
                    });
                  }
                }
              } else if (processedMessage.type == "DELETEDMESSAGE") {
                state.messages.data = state.messages.data.filter(
                  (message) => message.id != processedMessage.uuid
                );
              } else if (processedMessage.type == "UPDATEMESSAGE") {
                state.messages.data = state.messages.data.map((message) =>
                  message.id == processedMessage.data.id
                    ? processedMessage.data
                    : message
                );
              }
            }
          );

          // Subscribe to presence events for typing indicators lululu
          // newChannel.presence.subscribe("enter", (member) => {
          //   if (member.clientId !== state.user?.id) {
          //     const clientData = member.data.clientData;

          //     this.commit("setTypingStatus", {
          //       channelId: clientData.channelId,
          //       userId: member.clientId,
          //       user: clientData.user,
          //       typing: true,
          //     });
          //   }
          // });

          // newChannel.presence.subscribe("leave", (member) => {
          //   if (member.clientId !== state.user?.id) {
          //     const clientData = member.data.clientData;
          //     this.commit("clearTypingStatus", {
          //       channelId: clientData.channelId,
          //       userId: member.clientId,
          //     });
          //   }
          // });


        } else {
          console.error("Error: New channel not found");
        }
      } catch (error) {
        console.log(error);
      }

      //reset the missed messages count by filtering the messages in the conversation

      // old method
      // state.conversations.data = state.conversations.data.map(
      //   (conversation) => {
      //     if (conversation.uuid === data.uuid) {
      //       return {
      //         ...conversation,
      //         missed_messages: 0,
      //       };
      //     }
      //     return conversation;
      //   }
      // );


      state.conversations.data.forEach((conversation) => {
        if (conversation.uuid === data.uuid) {
          conversation.missed_messages = 0;
        }
      });

      

      //reset for conversations in conversation sections

      if(!state.conversation_sections.sections) return
      
      state.conversation_sections.sections.forEach(section => {
       
          section?.conversations?.forEach(conversation => {
            if (conversation.uuid === data.uuid) {
              // Directly update the properties
              conversation.missed_messages = 0;
              // Update other properties as needed
            }
          });
        
      });
      

    },

    SET_MESSAGE(state, data) {
      //  state.messages = data;

      state.messages.current_page = data.current_page;
      state.messages.total_size = data.total_size;
      state.messages.limit = data.limit;

      state.messages = {
        ...data,
        data: [...data.data.reverse()],
      };
    },

    SET_LOAD_MORE_MESSAGE(state, data) {
      // state.messages.data = [...state.messages.data, ...data.data];
      state.messages.data = [...data.data.reverse(), ...state.messages.data];
      state.messages.current_page = data.current_page; //another
    },

    MESSAGE_SENDING(state, data) {
      state.message_sending = data;
    },

    MESSAGE_LOADING(state, data) {
      state.message_loading = data;
    },
    MORE_MESSAGE_LOADING(state, data) {
      state.more_message_loading = data;
    },

    SET_NEW_CONVERSATION(state, data) {
      //check if the coversation is a global typ of conversation
      if (data.is_global) {
        state.global_conversations.data.unshift(data);
      } else {
        state.conversations.data.push(data);
      }
    },

    SET_NEW_SECTION(state, data) {
      state.conversation_sections.sections.push(data);
    },

    UPDATE_NEW_SECTION(state, data) {
      state.conversation_sections.sections =
        state.conversation_sections.sections.map((section) =>
          section.id === data.id ? data.data : section
        );
    },

    SET_NEW_MESSAGE(state, data) {
      state.messages.data.push(data);
    },

    UPDATE_MESSAGE(state, data) {
      state.messages.data = state.messages.data.map((message) =>
        message.id === data.id ? data.data : message
      );
    },
  },

  actions: {
    async oldinitializeAbly({ commit, state, dispatch }, data) {
      const { locationId, companyId } = data;
      try {
        const { ably_token } = await fetchTokens();

        const ably = new Ably.Realtime({ token: ably_token });

        ably.connection.on((stateChange) => {
          commit("setConnectionStatus", stateChange.current);

          if (
            stateChange.current === "disconnected" ||
            stateChange.current === "suspended"
          ) {
            dispatch("reconnect");
          } else if (stateChange.current === "connected") {
            //set the connection status to true   lalalal

            commit("setAblyClient", ably);

            commit("setInit", locationId);
            commit("setCompanyInit", { companyId, locationId });
          }
        });
      } catch (error) {
        console.error("Failed to initialize Ably client:", error);
        throw error;
      }
    },

    unSelectChat({ commit }) {
      commit("setShowConversations", true);
    },

    deleteMyChannel({ commit, state }, data) {
      commit("setDeleteChannel", data);
    },

    async olddinitializeAbly({ commit, dispatch }, data) {
      const { locationId, companyId, isAuth } = data;
      commit("setExternal", isAuth);
      try {
        const { ably_token } = await fetchTokens(isAuth);
        const ably = new Ably.Realtime({ token: ably_token });

        return new Promise((resolve, reject) => {
          ably.connection.on((stateChange) => {
            commit("setConnectionStatus", stateChange.current);

            if (
              stateChange.current === "disconnected" ||
              stateChange.current === "suspended"
            ) {
              dispatch("reconnect");
            } else if (stateChange.current === "connected") {
              commit("setAblyClient", ably);
              commit("setInit", locationId);
              commit("setCompanyInit", { companyId, locationId });

              resolve(); // Resolve the promise when Ably is fully initialized
            }
          });
        });
      } catch (error) {
        console.error("Failed to initialize Ably client:", error);
        throw error;
      }
    },



    async initializeAbly({ commit, dispatch }, data) {
      const { locationId, companyId, isAuth } = data;
      commit("setExternal", isAuth);
    
      try {
        // Fetch the initial token
        const initialToken = await fetchTokens(isAuth);
    
        // Initialize Ably with the initial token and authCallback for token renewal
        const ably = new Ably.Realtime({
          token: initialToken,
          authCallback: async (_, callback) => {
            const maxRetries = 3;
            let retryCount = 0;
    
            const fetchTokenWithRetry = async () => {
              try {
                const newToken = await fetchTokens(isAuth);
                callback(null, newToken);
              } catch (error) {
                retryCount++;
                if (retryCount < maxRetries) {
                  console.warn(`Retrying token fetch (attempt ${retryCount + 1})...`);
                  fetchTokenWithRetry();
                } else {
                  console.error("Max retries reached. Failed to fetch new Ably token:", error);
                  callback(error, null);
                }
              }
            };
    
            fetchTokenWithRetry();
          },
          authOptions: {
            authTimeout: 15000, // Increase timeout to 15 seconds
          },
        });
    
        // Listen for connection state changes
        ably.connection.on((stateChange) => {
          commit("setConnectionStatus", stateChange.current);
    
          if (stateChange.current === "disconnected" || stateChange.current === "suspended") {
            dispatch("reconnect");
          } else if (stateChange.current === "connected") {
            commit("setAblyClient", ably);
            commit("setInit", locationId);
            commit("setCompanyInit", { companyId, locationId });
          } else if (stateChange.current === "failed") {
            console.error("Ably connection failed. Attempting to reconnect...");
            setTimeout(() => {
              dispatch("reconnect");
            }, 5000); // Retry after 5 seconds
          }
        });
    
        // Return the Ably client for further use
        return ably;
      } catch (error) {
        console.error("Failed to initialize Ably client:", error);
        throw new Error("Unable to initialize Ably client. Please check your connection and try again.");
      }
    },

    async setTypingStatus({ commit, state }, data) {
      // { channelId, userId,user, typing }

      const channel = state.ablyClient?.channels?.get(data.channelUuid);
      const channelId = data.channelId;
      const userId = data.userId;
      const typing = data.typing;
      const user = data.user.first_name + " " + data.user.last_name;

      if (channel) {
        channel.presence.enter({
          clientData: { userId, channelId, user, typing },
        });
      }
    },

    clearTypingStatus({ commit, state }, data) {
      const channel = state.ablyClient?.channels?.get(data.channelUuid);
      const channelId = data.channelId;
      const userId = data.userId;
      const typing = data.typing;
      const user = data.user.first_name + " " + data.user.last_name;

      if (channel) {
        channel.presence.leave({
          clientData: { userId, channelId, user, typing },
        });
      }

      // const channel = state.ablyClient.channels.get(channelId);
      //   if(channel) {
      //   channel.presence.leave({ clientData: { userId, user } });
      //   }
    },

    removeActiveUser({ commit, state }) {
      const channel = state.ablyClient?.channels?.get(state.locationId);

      if (channel) {
        channel.presence.leave({ clientData: { user: state.user } });
      }
    },

    reconnect({ state, commit }) {
      let attempt = 0;
      const maxAttempts = 10;

      const tryReconnect = () => {
        attempt++;
        if (attempt <= maxAttempts) {
          commit("setConnectionStatus", `Reconnection attempt ${attempt}`);
          state.ablyClient.connection.connect();
        } else {
          commit("setConnectionStatus", "Disconnected");
        }
      };

      const exponentialBackoff = (attempt) => {
        return Math.min(1000 * Math.pow(2, attempt), 30000); // 30 seconds max
      };

      const reconnectWithBackoff = () => {
        if (
          state.ablyClient.connection.state === "disconnected" ||
          state.ablyClient.connection.state === "suspended"
        ) {
          tryReconnect();
          setTimeout(reconnectWithBackoff, exponentialBackoff(attempt));
        }
      };

      reconnectWithBackoff();
    },

    //push new conversations and new messages
    PushNewConversation({ commit, state }, data) {
      commit("SET_NEW_CONVERSATION", data);
    },

    PushNewSection({ commit, state }, data) {
      commit("SET_NEW_SECTION", data);
    },

    UpdateNewSection({ commit, state }, data) {
      commit("UPDATE_NEW_SECTION", data);
    },

    PushNewMessage({ commit, state }, data) {
      commit("SET_NEW_MESSAGE", data);
    },

    updateMessage({ commit, state }, data) {
      commit("UPDATE_MESSAGE", data);
    },

    updateMissedMessages({ commit, state }, data) {
      commit("setmissedMessages", data);
    },

    loadConversations({ commit, state }, data) {
      if (data.type != "global") {
        commit("SET_CONVERSATIONS_LOADING", true);
        commit("SET_Reset_CONVERSATIONS", []);
      }
      //conversation api
      const nextPage = CONVERSATIONS;
      axiosGet(nextPage, {
        params: {
          locationId: state.locationId,
          keyword: data.keyword,
          type: data.type,
          per_page: state.conversations.limit,
          page: state.conversations.current_page + 1,
        },
      }).then((response) => {
        if (data.type != "global") {
          commit("SET_CONVERSATIONS", response.data);
          commit("SET_CONVERSATIONS_LOADING", false);
        } else {
          commit("SET_GLOBAL_CONVERSATIONS", response.data);
        }

        //reset missed messges count
        commit("setmissedMessages", { type: "channel", total: 0 });
        commit("setmissedMessages", { type: "dm", total: 0 });
      });
    },

    loadConversationSection({ commit, state }, data) {
      // commit("SET_CONVERSATIONS_LOADING", true);

      axiosGet(`${CONVERSATIONS}/sections`, {
        params: {
          locationId: state.locationId,
          keyword: data.keyword,
        },
      }).then((response) => {
        commit("SET_CONVERSATION_SECTION", response.data);
      });
    },

    loadMoreConversations({ commit, state }, data) {
      commit("SET_MORE_CONVERSATIONS_LOADING", true);
      //conversation api
      const nextPage = CONVERSATIONS;

      axiosGet(nextPage, {
        params: {
          locationId: state.locationId,
          keyword: data.keyword,
          type: data.type,
          per_page: state.conversations.limit,
          limit: state.conversations.limit,
          page: state.conversations.current_page + 1,
        },
      }).then((response) => {
        commit("SET_LOAD_MORE_Conversations", response.data);

        commit("SET_MORE_CONVERSATIONS_LOADING", false);
      });
    },

    createConversation({ state, commit }, data) {
      return axiosPost(CONVERSATIONS, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => {
          const channelName = data.uuid;
        })
        .catch((e) => {});
    },

    loadChatUsers({ commit, state }, data = {}) {
      let action = data.action ?? "any";
      let all = data.all?1:0;

      commit("SET_CHAT_USERS", {
        loaded: false,
        error: false,
        data: [],
      });

      axiosGet(`${CHATUSERS}?all=${all}`)
        .then(({ data }) => {
          let users = data;

          users = users.map((u) => ({
            id: u.id,
            title: `${u.firstName} ${u.lastName}`,
            subTitle: u.email,
            email: u.email,
            firstName: u.firstName,
            phone: u.phone,
            lastName: u.lastName,
            role: u.roles.role,
            background: u.color,
          }));

          commit("SET_CHAT_USERS", {
            loaded: true,
            error: false,
            data: users,
          });
        })
        .catch((e) => {
          commit("SET_CHAT_USERS", {
            loaded: true,
            error: true,
            data: [],
          });
        });
    },
    selectMainContact({ commit }, data) {
      //commit the contact

      //commit("SET_MAIN_CONTACT", data);

      commit("SET_MESSAGE", {
        total_size: 0,
        limit: 25, //lalala
        current_page: 1,
        offset: 0,
        data: [],
      });

      commit("setActiveCon", data);
      commit("SET_MAIN_CONTACT_SELECTED", true);
      commit("SET_SELECTED_CONTACT", data);
      commit("MESSAGE_LOADING", true);

      axiosGet(`${CONVERSATIONS}/activities`, {
        params: {
          locationId: data,
        },
      }).then((response) => {
        commit("SET_MESSAGE", response.data);
        commit("MESSAGE_LOADING", false);
      });
    },

    selectContact({ commit, state }, data) {
      //commit the contact
      commit("SET_MAIN_CONTACT_SELECTED", false);
      commit("SET_SELECTED_CONTACT", data);
      commit("setActiveCon", data); 

      //let's paginate base on the number of missed messages.
      let limit = 25;
       if (data.missed_messages > limit) {
         limit = data.missed_messages + 2;
       }

      commit("SET_MESSAGE", {
        total_size: 0,
        limit: limit, 
        current_page: 1,
        offset: 0,
        data: [],
      });

      commit("MESSAGE_LOADING", true);
      //conversation api

      axiosGet(
        `${state.isAuth ? CONVERSATIONS : UNAUTHCONVERSATIONS}/${
          data.id
        }?limit=${limit}&page=1`,
      )
        .then((response) => {
          commit("SET_MESSAGE", response.data);
          commit("MESSAGE_LOADING", false);
        })
        .catch((response) => {
          commit("MESSAGE_LOADING", true);
        });
    },

    setConversationSection({ commit }, data) {
      commit("updateConversationSection", data);
    },
    
  

    creatMessage({ commit, state }, data) {
      commit("MESSAGE_SENDING", true);
      axiosPost(`${CONVERSATIONS}/${state.selectedContact?.id}/messages`, data)
        .then(({ data }) => {
          commit("MESSAGE_SENDING", false);
        })
        .catch((e) => {
          commit("MESSAGE_SENDING", false);
        });
    },

    //update selected channel

    updateSelectedContact({ commit }, data) {
      commit("SET_UPDATE_CONVERSATION", data);
    },

    updateSelectedContactUsers({ commit }, data) {
      commit("SETUPDATECONVERSATIONUSER", data);
    },

    loadMoreConversation({ commit, state }, data) {
      commit("SET_CONVERSATIONS_LOADING", true);
    },

    loadMoreMessages({ commit, state }, data) {
      //contruct the url to fetch the next page
      const url = `${CONVERSATIONS}/${state.selectedContact?.id}?page=${
        state.messages.current_page + 1
      } & limit=${state.messages.limit}`;

      commit("MORE_MESSAGE_LOADING", true);

      axiosGet(`${url}`).then((response) => {
        commit("SET_LOAD_MORE_MESSAGE", response.data);
        commit("MORE_MESSAGE_LOADING", false);
      });
    },
  },
};
